import { useEffect, useRef, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { AtvMessageDataType } from "@/api/AtvMessageApi";
import { ProviderInvoiceApi, ProviderInvoiceDataType } from "@/api/ProviderInvoiceApi";
import { FetchResponse } from "@/api/ApiClient";
import { ProviderInvoiceFormDataKeys } from "@/generated/ProviderInvoiceFormDataKeys";
import { ProviderInvoiceRelatedAttributes } from "@/formTypes/ProviderInvoiceDataType";
import moment from "moment";
import { renderEDocumentStatusOffCanvasTrigger } from "@utils/ModelIndexUtils";
import { formatMoneyValue } from "@utils/Currency";

const AtvMessageListByInvoiceId = () => {
  const params = useParams()
  const { invoiceId } = params;
  const modelRef = useRef<ModelIndexHandle>(null);
  const [invoiceData, setInvoiceData] = useState<ProviderInvoiceDataType>({});

  useEffect(() => {
    loadInvoice()
  }, [invoiceId]);

  const loadInvoice = async () => {
    if (invoiceId) {
      const selectionSet = [
        ...ProviderInvoiceFormDataKeys.filter(k => !ProviderInvoiceRelatedAttributes.includes(k)),
        "currency.*",
        "provider.*",
      ]
      const invoice = await ProviderInvoiceApi.get(invoiceId, { selectionSet });
      setInvoiceData(invoice)
      setTimeout(() => {
        modelRef?.current?.refetch()
      });
    } else {
      alert("No fue posible cargar la informacion de la factura")
    }
  }

  const getAtvMessages = async (): Promise<FetchResponse<AtvMessageDataType>> => {
    return {
      items: invoiceData?.atvMessages || []
    }
  }

  return (
    <PageContainer
      title={`Lista de Mensajes ATV de Factura #${invoiceData.numero || ""}`}
      backUrl="/user/provider-Invoices"
    >
      <ModelIndex<AtvMessageDataType>
        ref={modelRef}
        fetchData={() => getAtvMessages()}
        filterProps={[
          {
            key: "documentKey",
            filterType: "contains"
          },
          {
            key: "detalleMensaje",
            filterType: "contains"
          }
        ]}
        primaryProperties={[
          {
            key: "sequence",
            highlighted: true,
            className: styles.sequence
          },
          {
            key: (d) => d.provider?.nombre || "",
            alignment: "Start"
          },
        ]}
        primaryPropertiesSizing={
          [
            { sm: "4", xs: "12" },
            { sm: "8", xs: "12" }
          ]
        }
        secondaryProperties={[
          {
            key: (data) => {
              const date = moment(data.createdAt, "YYYY-MM-DD")
              return date.format("DD-MM-YYYY")
            },
            title: "Fecha",
          },
          {
            key: (data) => renderEDocumentStatusOffCanvasTrigger(data),
            title: "Estado ATV"
          },
          {
            key: (data) => {
              return formatMoneyValue(data.totalFactura, 1)
            },
            title: "Total",
            highlighted: true
          }
        ]}
        secondaryPropertiesSizing={
          [
            { sm: "4", md: "2" },
            { sm: "4", md: "3" },
            { sm: "4", md: "2" }
          ]
        }
      >
      </ModelIndex>
    </PageContainer >
  );
}

export default AtvMessageListByInvoiceId;
